import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ozow',
  templateUrl: './ozow.component.html',
  styleUrls: ['./ozow.component.scss']
})
export class OzowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
